import { createContext } from 'react'

export type TTpTimestampRangeCtx = {
  showDelay: boolean
  showTooltip: boolean
  showReason: boolean
  showEllipsis: boolean
  useSingleLine: boolean
  useShortDate: boolean
  useIntervalDescription: boolean
}

export const TpTimestampRangeCtx = createContext<TTpTimestampRangeCtx>({} as TTpTimestampRangeCtx)

const defaultTimestampRangeCtxValues: TTpTimestampRangeCtx = {
  showDelay: true,
  showTooltip: true,
  showReason: true,
  showEllipsis: false,
  useSingleLine: false,
  useShortDate: false,
  useIntervalDescription: false,
}

export const getTimestampRangeCtxValues = (values: Partial<TTpTimestampRangeCtx>): TTpTimestampRangeCtx => ({
  ...defaultTimestampRangeCtxValues,
  ...(values as TTpTimestampRangeCtx),
})
